import { useTranslation } from 'react-i18next';
import { Btn, Modal } from '@/presentation/component/ui';

interface UserDeleteModalProps {
  open: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const UserDeleteModal = ({ open, isLoading, onConfirm, onClose }: UserDeleteModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} title={t('admin.confirmDelete')} size="sm">
      <p className="text-sm text-[var(--color-ink-soft)]">{t('admin.confirmDeleteUser')}</p>
      <div className="mt-4 flex justify-end gap-2">
        <Btn kind="ghost" onClick={onClose}>
          {t('admin.cancel')}
        </Btn>
        <Btn kind="primary" onClick={onConfirm} disabled={isLoading} isLoading={isLoading}>
          {t('admin.deleteUser')}
        </Btn>
      </div>
    </Modal>
  );
};
